import { render, staticRenderFns } from "./DisplayTab.vue?vue&type=template&id=46ef580a&scoped=true"
import script from "./DisplayTab.vue?vue&type=script&lang=js"
export * from "./DisplayTab.vue?vue&type=script&lang=js"
import style0 from "./DisplayTab.vue?vue&type=style&index=0&id=46ef580a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ef580a",
  null
  
)

export default component.exports